import axios from 'axios';
import { toast } from 'sonner';
import { useTicketApi } from '../lib/ticketApi';


export const PLATFORM_STYLE = {
  kalshi: { letter: 'K', name: 'Kalshi', cls: 'bg-emerald-500 text-black border-emerald-300' },
  fanduel: { letter: 'F', name: 'FanDuel', cls: 'bg-blue-600 text-white border-blue-300' },
};

// Top-right K/F letter; tap to switch platform.
export default function PlatformBadge({ ticket, onChanged, className = '' }) {
  const api = useTicketApi();
  const st = PLATFORM_STYLE[ticket.platform];
  const next = ticket.platform === 'fanduel' ? 'kalshi' : 'fanduel';
  const swap = async (e) => {
    e.stopPropagation();
    try {
      await axios.patch(`${api.base}/parlays/${ticket.id}/platform`, { platform: next }, { headers: api.headers });
      toast.success(`Marked as ${PLATFORM_STYLE[next].name}`);
      onChanged?.();
    } catch (err) { toast.error(`Couldn't change platform: ${err.response?.data?.detail || err.message}`); }
  };
  return (
    <button type="button" onClick={swap} title={st ? `${st.name} — tap to switch` : 'Tap to set platform'}
      data-testid={`platform-badge-${ticket.id}`} data-platform={ticket.platform || 'none'}
      className={`absolute top-1 right-1 z-30 w-6 h-6 rounded-full border text-[12px] font-black flex items-center justify-center shadow transition-transform hover:scale-110 ${st ? st.cls : 'bg-zinc-800 text-zinc-500 border-zinc-600 border-dashed'} ${className}`}>
      {st ? st.letter : '?'}
    </button>
  );
}

export const PlatformPicker = ({ value, onChange }) => (
  <div className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-3" data-testid="platform-picker">
    <p className="text-sm text-white font-semibold mb-2">Which app are these tickets from?</p>
    <div className="grid grid-cols-2 gap-2">
      {Object.entries(PLATFORM_STYLE).map(([k, st]) => (
        <button key={k} type="button" onClick={() => onChange(k)} data-testid={`platform-pick-${k}`} aria-pressed={value === k}
          className={`flex items-center gap-2 rounded-lg border px-3 py-2.5 transition-colors ${value === k ? 'border-white bg-zinc-800' : 'border-zinc-700 hover:bg-zinc-800/60'}`}>
          <span className={`w-7 h-7 rounded-full border text-sm font-black flex items-center justify-center ${st.cls}`}>{st.letter}</span>
          <span className="text-sm text-white">{st.name}</span>
        </button>
      ))}
    </div>
    {!value && <p className="text-[11px] text-amber-300/90 mt-2">Pick one to start uploading.</p>}
  </div>
);
